module.exports = __webpack_public_path__ + "static/media/avalon.8a216ed9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/avalon.svg
// module id = 244
// module chunks = 0